import type {ColorSchemeName} from "react-native";
import {useColorScheme} from "react-native";

import {config} from "../components/ui/gluestack-ui-provider/config";

// TODO: share code from the config file above
type ModeType = "light" | "dark" | "system";
const getColorSchemeName = (colorScheme: ColorSchemeName, mode: ModeType): "light" | "dark" => {
    if (mode === "system") {
        return colorScheme ?? "light";
    }
    return mode;
};

// Keep in mind that this hook only works on the web platform
export function useColors() {
    const colorScheme = useColorScheme();
    const colorSchemeName = getColorSchemeName(colorScheme, "light");
    const colors = config[colorSchemeName];

    return colors;
}
